import * as i18next from 'i18next';
import { Languages } from '@src/constants/Constants';
import { Utils } from '@src/utils/Utils';
const translations = require('translations');

export namespace M {
    export class Config {
        public static getCleanMansLink(withLang: boolean = true): string {
            const mans: string = `${Utils.getBodyData('mans')}${withLang
                ? this.getLanguage()
                : ''}`;
            return mans;
        }

        public static getLanguage(): string {
            const lang: string = Utils.getBodyData('lang');
            return Languages.ALL.indexOf(lang) >= 0 ? lang : Languages.LV;
        }

        public static getMansLink(): string {
            return `${this.getCleanMansLink()}/my`;
        }

        public static getMansFormAction(): string {
            return `${this.getCleanMansLink()}/login-check`;
        }

        public static getLogOutUrl(): string {
            return `${this.getCleanMansLink()}/logout`;
        }

        public static getApiKey(): string {
            return Utils.getBodyData('apikey');
        }

        public static getResetPasswordEndPoint(): string {
            return `${this.getCleanMansLink()}/api/password-recover-common`;
        }

        public static init() {
            i18next.init(
                {
                    lng: Config.getLanguage(),
                    whitelist: Languages.ALL,
                    saveMissing: true,
                    debug: false,
                    interpolation: {
                        escapeValue: false,
                    },
                    resources: {
                        en: { translation: translations.en },
                        lv: { translation: translations.lv },
                        ru: { translation: translations.ru },
                    },
                },
                (err: any, t: any) => {
                    console.info('MConfig  | translations initialized');
                },
            );

            i18next.on('missingKey', function(
                lngs: any,
                namespace: any,
                key: any,
                res: any,
            ) {
                var _splitKeys = key.split('.');
                var _obj = {};
                _splitKeys.reduce(function(o: any, s: any) {
                    return (o[s] = {});
                }, _obj);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/controllers/M.ts